import React from 'react';
import RichText from '../../';
import { StyledRichTextContainer } from '../../StyledRichText/styles';

const TocRichText = ({ content, ...otherProps }) => {
  let tocIndex = 0;
  const article = content?.map(document => {
    if (document.content[0].nodeType === 'heading-2') {
      return (
        <div id={`toc-${tocIndex++}`}>
          <RichText content={document} />
        </div>
      );
    } else {
      return <RichText content={document} />;
    }
  });

  return <StyledRichTextContainer {...otherProps}>{article}</StyledRichTextContainer>;
};

export default TocRichText;
